//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        tags: {
            type: Array
        },
        selected: {
            type: String
        }
    },
    methods: {
        changeTag (e) {
            const { value } = e.currentTarget.dataset
            let selected = this.selected != value ? value : ''
            this.$emit('change', selected)
        }
    }
}
